"use client";

import { IGetBrandTopCategoryResponse } from "@faire/web-api/indigofair/data/IGetBrandTopCategoryResponse";
import { useStrictLocalization } from "@faire/web/common/localization";
import * as React from "react";

import { Breadcrumb as SharedBreadcrumb } from "@faire/retailer/components/Breadcrumb";
import { getBreadcrumbOptionsFromCategories } from "@faire/retailer/views/brand/getBreadcrumbOptionsFromCategories";

interface IProps {
  brandName: string | undefined;
  topCategory: IGetBrandTopCategoryResponse | undefined;
}

const REF_SC_DELIMITER = "|";

export const Breadcrumb: React.FC<IProps> = ({ brandName, topCategory }) => {
  const { strictLocalize } = useStrictLocalization();

  const getBreadCrumbOptions = (
    topCategory: IGetBrandTopCategoryResponse | undefined,
    brandName: string | undefined
  ) => {
    if (!topCategory) {
      return [];
    }

    const {
      category_name,
      subcategory_name,
      category_url_id,
      subcategory_url_id,
    } = topCategory;

    const breadcrumbs = getBreadcrumbOptionsFromCategories(
      {
        referrerCategoryName: category_name,
        referrerSubCategoryNames: subcategory_name?.split(REF_SC_DELIMITER),
        referrerCategoryUrlId: { id: category_url_id ?? "" },
        referrerSubCategoryUrlIds: subcategory_url_id
          ?.split(REF_SC_DELIMITER)
          ?.map((id) => ({
            id,
          })),
      },
      strictLocalize
    );

    if (brandName) {
      breadcrumbs.push({ label: brandName });
    }

    return breadcrumbs;
  };

  return (
    <SharedBreadcrumb options={getBreadCrumbOptions(topCategory, brandName)} />
  );
};
